import RouteNotFound from '@pages/route-not-found';
import { RoleGuardProps } from '@shared/types/components/role/role-guard.types';
import { hasRoleAccess } from '@shared/utils/roles/has-role-access.helper';

export const RoleGuard = ({ children, roles }: RoleGuardProps) => {
  if (!roles) return children;
  const [hasAccess] = hasRoleAccess(roles);
  return hasAccess ? children : <RouteNotFound />;
};
